import { Navigate, useLocation } from "react-router-dom";
import { getUser, hasRole, isAuthed } from "./auth";

export default function ProtectedRoute({ children, requireRole }: any) {
  const location = useLocation();
  if (!isAuthed()) {
    return <Navigate to="/login" replace />;
  }
  const localUser = getUser();
  const needsPlanSelection = localUser?.planSelectionCompleted === false;
  const isManagePlanMode =
    location.pathname === "/onboarding/plan" &&
    new URLSearchParams(location.search).get("mode") === "manage";
  if (needsPlanSelection && location.pathname !== "/onboarding/plan") {
    return <Navigate to="/onboarding/plan" replace />;
  }
  if (!needsPlanSelection && location.pathname === "/onboarding/plan" && !isManagePlanMode) {
    return <Navigate to="/home" replace />;
  }
  if (requireRole && !hasRole(requireRole)) {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}
